<div>
  @if (showInput) {
  <div>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Kommentar</mat-label>
      <textarea matInput cdkTextareaAutosize #commentTextarea [(ngModel)]="comment"></textarea>
      <button mat-icon-button matSuffix [disabled]="!comment" (click)="onSubmit()">
        <mat-icon>send</mat-icon>
      </button>
    </mat-form-field>
  </div>

  } @else {

  <button mat-button (click)="showInputField()">
    <mat-icon>{{ activationIcon }}</mat-icon>
    {{ activationLabel }}
  </button>
  }
</div>
